var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.03175 8.49998C6.90021 8.50074 6.76981 8.47553 6.64804 8.42579C6.52626 8.37605 6.4155 8.30277 6.32211 8.21013L0.325191 2.21321C0.136984 2.025 0.03125 1.76974 0.03125 1.50358C0.03125 1.23741 0.136984 0.982148 0.325191 0.793941C0.513398 0.605734 0.768661 0.5 1.03483 0.5C1.30099 0.5 1.55625 0.605734 1.74446 0.793941L7.03175 6.09122L12.319 0.803936C12.5102 0.640194 12.7562 0.554631 13.0077 0.564347C13.2593 0.574063 13.4979 0.678343 13.6759 0.856346C13.8539 1.03435 13.9582 1.27297 13.9679 1.52451C13.9776 1.77606 13.892 2.02201 13.7283 2.21321L7.73139 8.21013C7.54522 8.39478 7.29395 8.49888 7.03175 8.49998Z",
    fill: "#111314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.63330c941f6ca89138b990ac2ea98bb6.svg";
export { ForwardRef as ReactComponent };